import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/announcements/AnnouncementsClient.tsx");
